import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
    register = true;
  constructor() { }

  ngOnInit(): void {
  }

  showRegister(e:Event){
      this.register=!this.register;
      e.preventDefault();
  }

}
